import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import Select from "react-select-plus";
import CommonManager from '../../../../../helpers/common';
import {
  __,
  Alert,
  confirm
} from "modules/theme";
import {
  ModalForm,
  ModalFormContainer,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  ButtonCommonTheme,
} from "modules/theme";
import {
  RemoveCloseButton,
  QuickReply,
  PreviewMessage,
} from "../styles";

export class WhatsappTemplateAddEdit extends Component {
  constructor(props) {
    super(props);
    this.saveData = this.saveData.bind(this);
    this.mAPI = new APIManager();
    this.commonManager = new CommonManager();
    let edit = {};
    let header = {};
    if (this.props.infoData && this.props.infoData._id) {
      edit = this.props.infoData || {};
      header = this.props.infoData.header || {};
    }

    this.state = {
      templeteName : edit.templeteName || "",
      wabaId : edit.wabaId || null,
      categoris : edit.categoris || null,
      languge : edit.languge || null,
      header : {
        type : header.type || null, // 'text','media'
        mediaType : header.mediaType || "", // 'image', 'video', 'document'
        value : header.value || "",
        localUrl : header.localUrl || "",
        uploadType : header.uploadType || "",
      },
      file : "",
      body : edit.body || "",
      footer : edit.footer || "",
      buttons : edit.buttons || [],
      buttonType : edit.buttonType || null,
      wabaList : [],
    };
  }

  componentDidMount() {
    this.getWebId();
  }
  language(){
    return [{"label":"Afrikaans","value":"af"},
    {"label":"Albanian","value":"sq"},
    {"label":"Arabic","value":"ar"},
    {"label":"Azerbaijani","value":"az"},
    {"label":"Bengali","value":"bn"},
    {"label":"Bulgarian","value":"bg"},
    {"label":"Catalan","value":"ca"},
    {"label":"Chinese (CHN)","value":"zh_CN"},
    {"label":"Chinese (HKG)","value":"zh_HK"},
    {"label":"Chinese (TAI)","value":"zh_TW"},
    {"label":"Croatian","value":"hr"},
    {"label":"Czech","value":"cs"},
    {"label":"Danish","value":"da"},
    {"label":"Dutch","value":"nl"},
    {"label":"English","value":"en"},
    {"label":"English (UK)","value":"en_GB"},
    {"label":"English (US)","value":"en_US"},
    {"label":"Estonian","value":"et"},
    {"label":"Filipino","value":"fil"},
    {"label":"Finnish","value":"fi"},
    {"label":"French","value":"fr"},
    {"label":"Georgian","value":"ka"},
    {"label":"German","value":"de"},
    {"label":"Greek","value":"el"},
    {"label":"Gujarati","value":"gu"},
    {"label":"Hausa","value":"ha"},
    {"label":"Hebrew","value":"he"},
    {"label":"Hindi","value":"hi"},
    {"label":"Hungarian","value":"hu"},
    {"label":"Indonesian","value":"id"},
    {"label":"Irish","value":"ga"},
    {"label":"Italian","value":"it"},
    {"label":"Japanese","value":"ja"},
    {"label":"Kannada","value":"kn"},
    {"label":"Kazakh","value":"kk"},
    {"label":"Kinyarwanda","value":"rw_RW"},
    {"label":"Korean","value":"ko"},
    {"label":"Kyrgyz (Kyrgyzstan)","value":"ky_KG"},
    {"label":"Lao","value":"lo"},
    {"label":"Latvian","value":"lv"},
    {"label":"Lithuanian","value":"lt"},
    {"label":"Macedonian","value":"mk"},
    {"label":"Malay","value":"ms"},
    {"label":"Malayalam","value":"ml"},
    {"label":"Marathi","value":"mr"},
    {"label":"Norwegian","value":"nb"},
    {"label":"Persian","value":"fa"},
    {"label":"Polish","value":"pl"},
    {"label":"Portuguese (BR)","value":"pt_BR"},
    {"label":"Portuguese (POR)","value":"pt_PT"},
    {"label":"Punjabi","value":"pa"},
    {"label":"Romanian","value":"ro"},
    {"label":"Russian","value":"ru"},
    {"label":"Serbian","value":"sr"},
    {"label":"Slovak","value":"sk"},
    {"label":"Slovenian","value":"sl"},
    {"label":"Spanish","value":"es"},
    {"label":"Spanish (ARG)","value":"es_AR"},
    {"label":"Spanish (SPA)","value":"es_ES"},
    {"label":"Spanish (MEX)","value":"es_MX"},
    {"label":"Swahili","value":"sw"},
    {"label":"Swedish","value":"sv"},
    {"label":"Tamil","value":"ta"},
    {"label":"Telugu","value":"te"},
    {"label":"Thai","value":"th"},
    {"label":"Turkish","value":"tr"},
    {"label":"Ukrainian","value":"uk"},
    {"label":"Urdu","value":"ur"},
    {"label":"Uzbek","value":"uz"},
    {"label":"Vietnamese","value":"vi"},
    {"label":"Zulu","value":"zu"}]
  }

  getWebId() {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/wpSender?limit=200&page_no=1`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({
            wabaList: data.data.map((d) => d.wabaid),
          });
        } else {
          that.setState({ wabaList: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
      }
    );
  }
  resetAllData() {
    this.setState({
      name: "",
      type: "",
    });
  }
  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
    }
  }
  saveData(e) {
    e.preventDefault();
    
    let _this = this;
    let header = this.state.header || {};
    let uploadType = header.uploadType || "";


    let tData = {
      'templeteName' : this.state.templeteName,
      'wabaId' : this.state.wabaId,
      'categoris' : this.state.categoris,
      'languge' : this.state.languge,
      'header' : this.state.header,
      'file' : this.state.file,
      'body' : this.state.body,
      'footer' : this.state.footer,
      'buttons' : this.state.buttons,
      'buttonType' : this.state.buttonType,
    };

    if (this.props.infoData && this.props.infoData._id) {
      this.mAPI.sendPostAPI(
        `"wp-templete/${this.props.infoData._id}`,
        tData,
        (data) => {
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`Name ${tData.name} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "private",
        { id: tData._id },
        "PUT"
      );
    } else {
      let fileValue = header.value || "";
      if( uploadType == "file" ){
        delete header.value;
      }
      let formData = this.commonManager.formDataAppend(tData);
      if( uploadType == "file" && fileValue ){
        formData.append('file', fileValue);
      }
      this.mAPI.sendPostForm(
        "wp-templete",
        formData,
        (data) => {
          if (data && data.message) {
            Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }
  generateEntitysParams(list) {
    if( list && list.length ){
      return list.map((entity) => ({
        value: entity,
        label: entity,
      }));
    } else {
      return [];
    }
  }
  mediaTypeOption( mediaType ) {
    let option = {
      text : "",
      accept : "",
    }
    switch (mediaType) {
      case 'image':
        option.text = `(Image: .jpeg, .png)`;
        option.accept = `image/*`;
        break;
      case 'video':
        option.text = `(Video: .mp4)`;
        option.accept = `video/*`;
        break;
      case 'document':
        option.text = `(Document: .pdf)`;
        option.accept = `.pdf`;
      break;
      default:
        break;
    }
    return option;
  }
  isValidUrl(urlString) {
	  	var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
	    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
	    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
	    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
	    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
	    '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
	  return !!urlPattern.test(urlString);
  }
  renderHeaderOptions() {
    let { uploadType, mediaType, value } = this.state.header;
    let { text, accept } = this.mediaTypeOption( mediaType )
    return (
      <div className="mt-4">
        <p style={{ color: "#0e71c3", }}>
          { text }
        </p>
        <div className="d-flex align-items-center mt-3">
          <FormControl
            placeholder="Enter URL"
            value={uploadType === "url" ? value : ""}
            style={{ marginRight: "15px", width: "220px" }}
            onChange={(e) => {
              this.state.header.value = "";
              this.state.header.uploadType = "";
              this.state.header.localUrl = "";
              if( e.target.value ){
                this.state.header.value = e.target.value;
                this.state.header.uploadType = 'url';
                if( this.isValidUrl(e.target.value)){
                  this.state.header.localUrl = e.target.value; // local media url
                }
              }
              this.setState({ header: this.state.header });
            }}
          />
          <b>or</b>
          <input
            type="file"
            accept={accept}
            id="files"
            class="hidden"
            onChange={(e) => {
              // this.setState({
              //   imgUploadUrl: URL.createObjectURL(e.target.files[0]),
              // });
              this.state.header.value = "";
              console.log("e.target.files", e.target.files)
              if( e.target.files && e.target.files[0] ){
                let localUrl = "";
                try {
                  localUrl = URL.createObjectURL(e.target.files[0])
                } catch (error) {
                  console.log("localUrl error", error)
                }
                this.state.header.uploadType = 'file';
                this.state.header.value = e.target.files[0];
                this.state.header.localUrl = localUrl;
              } else {
                console.log("FIles not found");
              }
              this.setState({ header: this.state.header });
            }}
          />
          <label
            className="darkblue-btn"
            style={{
              color: "white",
              padding: "8px",
              borderRadius: "8px",
              marginLeft: "15px",
              marginBottom: "0",
            }}
            for="files"
          >
            Upload Media
          </label>
        </div>
      </div>
    );
  }
  renderHeaderElement() {
    console.log("renderHeaderElement", this.state);
    if( !this.state.header || !this.state.header.type ){
      return (
        <React.Fragment/>
      )
    }

    if( this.state.header.type === "media" ) {
      let mediaType = this.state.header.mediaType || "";
      return (
        <div className="d-flex w-100 justify-content-between">
          <div class="d-flex flex-column mt-4">
            {
              ["image","video","document"].map((type)=>{
                return (
                  <span className="d-flex m-1 w-100">
                    <input
                      className="m-1"
                      type="radio"
                      id={type}
                      name={type}
                      value={type}
                      checked={mediaType === type ? true : false}
                      onChange={(event)=>{
                        this.state.header.mediaType = "";
                        this.state.header.value = "";
                        this.state.header.localUrl = "";
                        this.state.header.uploadType = "";
                        if( event.target.value ){
                          this.state.header.mediaType = event.target.value;
                        }
                        this.setState({ header: this.state.header });
                      }}
                    />
                    <label className="m-1" for="image">
                      {type}
                    </label>
                  </span>
                )
              })
            }
          </div>
            {mediaType && this.renderHeaderOptions()}
        </div>
      );
    } else if ( this.state.header.type === "text" ) {
      return (
        <FormGroup className='d-flex w-100 align-items-center mt-4'>
          <ControlLabel className='mb-0 mt-0' style={{marginRight: '20px', width: '120px'}}>Message</ControlLabel>
          <FormControl
            placeholder="Enter Text"
            style={{ width: '220px' }}
            value={this.state.header.value}
            onChange={(e) => {
              this.state.header.value = "";
              this.state.header.localUrl = "";
              this.state.header.uploadType = "";
              if( e.target.value ){
                this.state.header.value = e.target.value;
              }
              this.setState({ header: this.state.header });
            }}
          />
        </FormGroup>
      );
    }
  }
  renderButtonOption() {
    return (
      <ButtonCommonTheme
        type='blueModalBtn'
        modalBtnTitle='Add Button'
        onClick={() => {}}
      />
    )
  }
  renderForm() {
    return (
      <React.Fragment>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <FormGroup>
            <ControlLabel required={true}>{"Template Name"}</ControlLabel>
            <FormControl
              placeholder="Name"
              style={{ width: "220px" }}
              value={this.state.templeteName}
              onChange={(e) => {
                let templeteName = "";
                // remove space between word in save
                // if( e.target.value ){
                //   templeteName = e.target.value.trim();
                // }
                this.setState({ templeteName: e.target.value });
              }}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel required={true}>{"Language"}</ControlLabel>
            <Select
              style={{ width: "220px" }}
              multi={false}
              options={this.language()}
              onChange={(selected) => {
                // let languge = "";
                if( selected && selected.value ){
                  // languge = selected.value;
                  this.setState({ languge: selected.value });
                } else {
                  this.setState({ languge: null });
                }
              }}
              value={this.state.languge}
            />
          </FormGroup>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <FormGroup>
            <ControlLabel required={true}>{"WEB ID"}</ControlLabel>
            <Select
              style={{ width: "220px" }}
              multi={false}
              options={this.generateEntitysParams(this.state.wabaList)}
              onChange={(selected) => {
                // let wabaId = "";
                if( selected && selected.value ){
                  // wabaId = selected.value;
                  this.setState({ wabaId: selected.value });
                } else {
                this.setState({ wabaId: null });
                }
              }}
              value={this.state.wabaId}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel required={true}>{"CATEGORIES"}</ControlLabel>
            <Select
              style={{ width: "220px" }}
              multi={false}
              options={this.generateEntitysParams([
                // "AUTHENTICATION",
                // "UTILITY",
                "MARKETING",
                "TRANSACTIONAL", 
                "OTP",
              ])}
              onChange={(selected) => {
                // let categoris = "";
                if( selected && selected.value ){
                  // categoris = selected.value;
                  this.setState({ categoris: selected.value });
                } else {
                  this.setState({categoris: null});
                }
              }}
              value={this.state.categoris}
            />
          </FormGroup>
        </div>
        <FormGroup className="d-flex flex-column" >
          {/* <div style={{ display: "flex", alignItems: "center" }}> */}
            {/* <div style={{ width: "230px" }}> */}
            <div className="w-100 d-flex align-items-center" style={{ flexWrap: 'wrap' }}>
              <ControlLabel required={false} style={{marginRight: '20px'}}>
                {"Header (Optional)"}
              </ControlLabel>
            {/* </div> */}
            <div style={{width: '220px'}}>
            <Select
              placeholder="None"
              // style={{ width: "220px" }}
              multi={false}
              options={this.generateEntitysParams(["none","text", "media"])}
              onChange={(selected) => {
                // let header = {
                //   type: null,
                //   mediaType: "",
                //   value: "",
                //   localUrl: "",
                //   uploadType: "",
                // };
                if( selected && selected.value && selected.value != "none" ){
                  this.setState({header: {...this.state.header, type: selected.value}});
                } else {
                  this.setState({header: {...this.state.header, type: null}})
                }
                // type : "", // 'text','media'
                // mediaType : "", // 'image', 'video', 'document'
                // value : "",
                // this.setState({ header: header });
              }}
              value={this.state.header.type}
            />
            </div>
          {/* </div> */}
          </div>
          {this.renderHeaderElement()}
        </FormGroup>
        <FormGroup>
          <ControlLabel required={true}>{"Body"}</ControlLabel>
          <FormControl
            placeholder="Enter the text for your message in the language you've selected."
            style={{padding: '20px'}}
            value={this.state.body}
            componentClass={'textarea'}
            onChange={(e) => {
              this.setState({ body: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel required={false}>{"Footer"}</ControlLabel>
          <FormControl
            placeholder="Add a short line of text to the bottom of your message template. "
            style={{}}
            value={this.state.footer}
            onChange={(e) => {
              this.setState({ footer: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup style={{ display: "flex" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{}}>
              <ControlLabel required={false}>
                {"Buttons (Optional)"}
              </ControlLabel>
            </div>
            {/* <FormControl placeholder="None" style={{ width: '220px' }} /> */}
            <Select
              placeholder="None"
              style={{ width: "220px" }}
              multi={false}
              options={[
                {value:"",label:"None"},
                {value:"quickReplay",label:"Quick Reply"},
                {value:"callToAction",label:"Call to Action"},
              ]}
              onChange={(selected) => {
                // let buttonType = "";
                if( selected && selected.value ){
                  this.setState({buttonType: selected.value});
                } else {
                  this.setState({buttonType: null});
                }
                // this.setState({ buttonType: buttonType });
              }}
              value={this.state.buttonType}
            />
            {this.state.buttonType && this.renderButtonOption()}
          </div>
          {/* {this.renderButtonOptionElement()} */}
        </FormGroup>
      </React.Fragment>
    )
  }
  renderPreviewHeader() {
    if( this.state.header && this.state.header.type ){
      if( this.state.header.type == 'text' ){
        return ( <div className="header-text">{this.state.header.value || ""}</div> )
      } else if( this.state.header.type == 'media' ){

        if( this.state.header.mediaType == 'image' && ( this.state.header.uploadType == 'file' || this.state.header.uploadType == 'url' || this.state.header.uploadType == '' ) ){
          let url = this.state.header.localUrl ? this.state.header.localUrl : "/images/previews/template-image.png";
          let className = this.state.header.localUrl ? "header-uploaded-image" : "header-image";
          return (
            <div>
              <img
                className={className}
                src={url}
              />
            </div>
          );
        } else if( this.state.header.mediaType == 'video' ){
          let url = this.state.header.localUrl ? this.state.header.localUrl : "";
          return (
            <div>
              <video
                style={{ display: "block", margin: "auto", width: "100%" }}
                controls
                src={url}
              ></video>
            </div>
          );
        } else if( this.state.header.mediaType == 'document' ){
          
          let url = this.state.header.localUrl ? this.state.header.localUrl : "/images/previews/template-image.png";
          let className = this.state.header.localUrl ? "" : "header-image";
          return (
            <div>
              <embed
                className={className}
                src={url}
                type="application/pdf"
                frameBorder="0"
                scrolling="auto"
                height="100%"
                width="100%"
              ></embed>
            </div>
          );
        } else { 
          return (
            <React.Fragment/>
          );
        }
      } else {
      }
    } else {
      return (
        <React.Fragment/>
      );
    }
  }
  renderPreviewBody() {
    if( this.state.body){
      return (
        <p style={{ color: "#333" }}>{this.state.body}</p>
      );
    } else {
      return (
        <React.Fragment/>
      );
    }
  }
  renderPreviewFooter() {
    if( this.state.footer){
      return (
        <p className="footer-message">{this.state.footer}</p>
      );
    } else {
      return (
        <React.Fragment/>
      );
    }
  }
  renderPreviewButton() {
    if( this.state.footer){
      return (
        <p className="footer-message">{this.state.footer}</p>
      );
    } else {
      return (
        <React.Fragment/>
      );
    }
  }
  renderPreview() {
    return (
      <FormGroup>
        <ControlLabel>{"Preview"}</ControlLabel>
        <PreviewMessage>
          {this.renderPreviewHeader()}
          {this.renderPreviewBody()}
          {this.renderPreviewFooter()}
          {this.renderPreviewButton()}
        </PreviewMessage>
      </FormGroup>
    );
  }
  render() {
    const { __ } = this.context;
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)} autoComplete={false}>
        <ModalFormContainer>
          <div className="row">
            <div className="col-7" style={{ height: "520px", overflow: "auto" }}>
              {this.renderForm()}
            </div>
            <div className="col-5 pt-3" style={{ overflow: "auto", background: "#f3e5d2" }}>
              {this.renderPreview()}
            </div>
          </div>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
            <ButtonCommonTheme
              type='greyModalBtn'
              style={{ marginLeft: "10px" }}
              modalBtnTitle='Cancel'
              onClick={() => this.props.closeModal()}
            />
            <ButtonCommonTheme
              type='blueModalBtn'
              btnType='submit'
              modalBtnTitle={this.props.editData && this.props.editData._id ? "Update" : "Add"}
              onClick={() => {}}
            />
        </ModalFooter>
      </ModalForm>
    );
  }
}

WhatsappTemplateAddEdit.propTypes = {
  group: PropTypes.array,
};

WhatsappTemplateAddEdit.contextTypes = {
  __: PropTypes.func,
};

export default WhatsappTemplateAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsappTemplate/components/WhatsappTemplateAddEdit.js